import React, { useState, useEffect, useContext } from "react";
import { ClientContext } from "../../context/Client/ClientContext";

const ClientCategories = ({ handleBackBtn, client }) => {
  const [categories, setCategories] = useState([]);

  const { getClientCategories } = useContext(ClientContext);

  useEffect(() => {
    const fetchData = async () => {
      if (!client?.clientId) return;

      const res = await getClientCategories(client.clientId);
      setCategories(res?.data || []);
    };

    fetchData();
  }, [client?.clientId, getClientCategories]);

  return (
    <div className="gog-client-attributes">
      <div className="gog-inner-section-header">
        <span>Attributes</span>
        <h3>Business Attributes</h3>
        <p>View the classes and attributes connected to this merchant.</p>
      </div>

      {categories.length > 0 ? (
        <div className="gog-attribute-table">
          <div className="gog-attribute-table-head">
            <span>Class</span>
            <span>Attribute</span>
          </div>

          <div className="gog-attribute-table-body">
            {categories.map((cat, idx) => (
              <div key={idx} className="gog-attribute-table-row">
                <strong>{cat.className || "—"}</strong>

                <span>
                  {cat.attrName ? (
                    <>
                      <b>›</b>
                      {cat.attrName}
                    </>
                  ) : (
                    <em>Not specified</em>
                  )}
                </span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="gog-empty-state">
          No attributes are available for this merchant.
        </div>
      )}

      <div className="gog-inner-action-row">
        <button type="button" onClick={handleBackBtn} className="gog-light-btn">
          Back
        </button>
      </div>
    </div>
  );
};

export default ClientCategories;